import React from 'react';
import { Link } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { PageHead, usePortal } from './shared';

const FAQ = [
  ['Why isn\'t my offer showing to customers?', 'Cheers2Night checks every offer before it goes live, and your venue details must be verified. It must also be published, switched Active, confirmed as accurate by you, and running today (dates and days). Alcohol, happy-hour and dining-bill offers that cover alcohol also need alcohol offers to be allowed on the platform and a verified liquor licence (Venue Profile). The offer card says why it\'s hidden.'],
  ['Who is responsible for my offers?', 'You are: every offer comes from your venue, and you confirm it is accurate and lawful when you publish it. Cheers2Night reviews offers but doesn\'t create or guarantee them.'],
  ['How do customers use an offer?', 'Cheers2Night is for discovery only: customers see your offer, then call you or come to your venue and ask for it. There\'s no claiming, booking or payment on Cheers2Night.'],
  ['Which image is shown on my offer?', 'The first image in the offer\'s gallery is its cover. Drag images to reorder them.'],
  ['How do I change my venue name or address?', 'Email support with the new details and we\'ll update your listing.']
];

const SupportPage: React.FC = () => {
  const { account } = usePortal();
  const subject = encodeURIComponent(`Partner support${account ? ` - ${account.name} (#${account.restoId})` : ''}`);
  return (
    <>
      <PageHead title="Support" subtitle="We're here to help you get the most out of Cheers2Night." />
      <div className="pp-grid2" style={{ alignItems: 'start' }}>
        <section className="pp-panel">
          <h3 style={{ marginTop: 0 }}>Contact Us</h3>
          <p className="pp-muted">Write to us with your question. Include your venue name so we can help faster.</p>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <a className="pp-btn pp-gold" href={`mailto:support@cheers2night.com?subject=${subject}`}><MailOutlineIcon />support@cheers2night.com</a>
            <Link className="pp-btn pp-outline" to="/contact"><ChatBubbleOutlineIcon />Contact Form</Link>
          </div>
        </section>
        <section className="pp-panel">
          <h3 style={{ marginTop: 0 }}>Common Questions</h3>
          {FAQ.map(([q, a]) => (
            <details key={q} style={{ borderBottom: '1px solid var(--pp-line)', padding: '10px 0' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{q}</summary>
              <p className="pp-muted" style={{ margin: '8px 0 0' }}>{a}</p>
            </details>
          ))}
        </section>
      </div>
    </>
  );
};

export default SupportPage;
